import React from "react";
import { connect } from "react-redux";

import { getDinnerBookingByID } from "state/school_money/selectors";
import { removeDinnerBookingFromBasket } from "state/school_money/actions";

import Date from "components/Date";
import Currency from "components/Currency";
import RemoveButton from "components/school_money/RemoveButton";

import "./DinnerBooking.css";

class DinnerBooking extends React.Component {
  
  render() {
    
    const { dinnerBooking, price } = this.props;
    const { description, startDate } = dinnerBooking.toJS();
    
    return (
      <div className="dinner-booking-basket-item">
        <div className="dinner-booking-basket-item__label">
          <div className="dinner-booking-basket-item__description">{description}</div>
          <div className="dinner-booking-basket-item__date">W/C <Date date={startDate} /></div>
        </div>
        <div className="dinner-booking-basket-item__price">
          <Currency className="dinner-booking-basket-item__amount" amount={price} />
          <RemoveButton className="dinner-booking-basket-item__remove-button" onClick={this.props.remove} />
        </div>
      </div>
    );
    
  }
  
}

export default connect(
  (state, { dinnerBookingID }) => ({
    dinnerBooking: getDinnerBookingByID(state, dinnerBookingID)
  }),
  (dispatch, { dinnerBookingID }) => ({
    remove: () => dispatch(removeDinnerBookingFromBasket(dinnerBookingID))
  })
)(DinnerBooking);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/items/dinnerBooking/DinnerBooking.js